
import { oem_info } from '@/api'
import { DEV } from '@/utils/env'


export default {
  state: {
    isOEM: !location.hostname.includes('zhutui.cn') && !DEV,
    // isOEM:true,
    // isOEM: !location.hostname.includes('zhutui.cn'),

    id: '',
    logo: '',
    domain: '',
    title: '',
  },

  mutations: {
    // 设置oem信息
    UPDATE_OEMInfo: (state, info) => setInfo(state, info),

    UPDATE_OEM: (state, isOEM) => state.isOEM = isOEM,
  },

  actions: {
    // 获取OEM信息
    async GetOEM({ commit, dispatch }) {
      // const { data } = await oem_info({ domain: location.hostname })
      const { data } = await oem_info({ id: 2 })

      if (data.error_code == 0) {
        commit('UPDATE_OEM', true)
        commit('UPDATE_OEMInfo', data.info)
      }
      dispatch('SetOEMTitle', data.info)

      return data
    },

    // 设置oem站点页面信息
    SetOEMTitle(state, info={}) {
      // 页面标题
      document.title = info.title || '推广中心 - 主推网'

      // ico图片
      if (info.ico) {
        let icoEle = document.querySelector('[rel="icon"]')
        if (!icoEle) {
          icoEle = document.createElement('link')
          icoEle.setAttribute('rel', 'icon')
        }
        icoEle.setAttribute('href', info.ico)
        window.document.head.appendChild(icoEle)
      }
    },
  },
}

import Vue from 'vue'
// 设置info类型的数据，比如用户信息等等
function setInfo(state, info) {
  Object.keys(info).forEach((key) => {
    const value = info[key]

    if ( state[key] != undefined ) {
      state[key] = value
    }
    else {
      Vue.set(state, key, value)
    }

  })
  
}